import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import { IButtonProps } from '../../constants/commonTypes';

const AxisButton = (props: IButtonProps) => {

  const {
    children,
    disabled,
    endIcon,
    fullWidth,
    href,
    startIcon,
    variant,
    customStyle,
    onClick,
    ...rest
  } = props;

  return (
    <Button
      disabled={disabled}
      endIcon={endIcon}
      fullWidth={fullWidth}
      href={href}
      startIcon={startIcon}
      variant={variant}
      className={customStyle}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  )
}

AxisButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  endIcon: PropTypes.node,
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  startIcon: PropTypes.node,
  variant: PropTypes.oneOf(['contained', 'outlined', 'text']),
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default AxisButton;